module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 032.db13ffb0.jpg";